import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators, } from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';
import { frequencyDays } from '../../_models/staticArray'
import { Router } from '@angular/router';
import { I18nPluralPipe } from '@angular/common';
@Component({
    selector: 'app-job-dates',
    templateUrl: './job-dates.component.html',
    styleUrls: ['./job-dates.component.scss']
})
export class JobDatesComponent implements OnInit {
    public frequencyDays = [
        { id: '0', day: 'Sunday', checked: false },
        { id: '1', day: 'Monday', checked: false },
        { id: '2', day: 'Tuesday', checked: false },
        { id: '3', day: 'Wednesday', checked: false },
        { id: '4', day: 'Thursday', checked: false },
        { id: '5', day: 'Friday', checked: false },
        { id: '6', day: 'Saturday', checked: false }
    ];
    @Input('frequency') frequency: any;
    @Input('duration') duration: any;
    @Input('startingDate') startingDate: any;
    @Input('singleJobDate') singleJobDates: any; // for edit event
    @Input('datesOnCourseChange') datesOnCourseChange: any; // generate new dates on course change
    @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();
    @Input('loginUser') userLogin
    @Input('jobReset') resetJob
    @Input('endingDate') endDateValue
    @Input('dateChangeValue') changeDateValue
    @Input('isFatigue') viewFatigue
    @Input('validationData') dateValidation
    @Input('jobStart') jobStartTime
    @Input('jobEnd') jobEndTime

    // @Input('calculateDates')

    dateForm;
    courseDates = [];
    temp = moment(this.startingDate)
    tempArray = [];
    finalCourseDates;
    dayOfTheWeek;
    day;
    event;
    totalDays = [];
    dayExist: Boolean;
    checkEnable: Boolean = true;
    user;
    endDate
    isDisplay = false
    existingDates = []
    singleJobDate
    startTime
    endTime
    constructor(
        public formBuilder: FormBuilder,
        public router: Router,
        public _cd: ChangeDetectorRef
    ) {
        this.user = JSON.parse(localStorage.getItem('userRoles'))
    }

    ngOnInit() {
        console.log("IN JOBDATE", "DAY OF THE WEEK", this.dayOfTheWeek, this.frequency, "DURATION IS ==", this.duration, "STARTING DATE IS: ", this.startingDate, this.singleJobDate)
        if (this.router.url.includes('labour-job/create') || this.router.url.includes('labour-job/view') || this.router.url.includes('client/view') || this.router.url.includes('add-job')) {
            this.temp = moment(this.startingDate)

            this.dateForm = this.formBuilder.group({
                frequency: new FormArray([], Validators.required),
                // singleJobDates : new FormControl()
            })
            this.addCheckboxes();

            if (this.frequency != undefined) {
                console.log("this.frequency in edit!!!!!!!!!!", this.frequency);
                this.checkEnable = false;
                this.frequency.forEach((item => {
                    this.frequencyDays.forEach((arrayItem) => {
                        if (arrayItem.day == item) {
                            arrayItem.checked = true
                        }
                    })
                }))
                this.courseDates = []
                this.singleJobDate.forEach((date) => {
                    // let temp = new Date(date.date)
                    this.courseDates.push(date)
                })
                console.log("this is the course dates", this.courseDates);

                // this.finalCourseDates = this.courseDates.sort((a, b) => b - a).reverse();
            }
        }
    }


    addCheckboxes() {
        this.frequencyDays.forEach(() => {
            const control = new FormControl();
            (this.dateForm.controls.frequency as FormArray).push(control);
        });
    }

    enableCheckBoxes() {
        this.checkEnable = false
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log("in changes in job dates", changes)
        if (changes.datesOnCourseChange && changes.datesOnCourseChange.currentValue) {
            this.onCourseChange()
        }


        if (changes.startingDate && changes.startingDate.currentValue) {
            this.startingDate = changes.startingDate.currentValue
            this.temp = moment(this.startingDate)
            this.dateForm = this.formBuilder.group({
                frequency: new FormArray([], Validators.required),
                // singleJobDates : new FormControl()
            })
            // this._cd.de
            this.addCheckboxes()
        }

        if (changes.endDateValue && changes.endDateValue.currentValue) this.endDate = changes.endDateValue.currentValue

        if (changes.duration && changes.duration.currentValue) {
            console.log("WAHT IS THE DATE ARRAY TO BE UPDATE", this.finalCourseDates);

            this.enableCheckBoxes()

            if (this.finalCourseDates && this.finalCourseDates.length) {
                this.courseDates = []
                this.finalCourseDates = []
                this.frequency.forEach((oneDay) => {
                    let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                    if (index > -1) {
                        console.log("index", index)
                        let dayOfWeek = this.frequencyDays[index].id
                        let event = true
                        this.generateDates(event, dayOfWeek, oneDay)
                    }
                })
            }

        }
        if (changes.resetJob && changes.resetJob.currentValue) {
            this.finalCourseDates = []
            // this.addCheckboxes()
            this.clearCheckBoxes()
        }

        if (changes.frequency && changes.frequency.currentValue) {
            this.frequency = []
            this.frequency = changes.frequency.currentValue
            this.totalDays = changes.frequency.currentValue
            this.checkEnable = false;

            this.frequency.forEach((item => {
                console.log("this is the total days of job", this.frequency);
                this.frequencyDays.forEach((arrayItem) => {
                    if (arrayItem.day == item) {
                        arrayItem.checked = true
                    }
                    // else {
                    //     arrayItem.checked = false
                    // }
                })
            }))
            if (this.frequency && !this.frequency.length) {
                this.frequencyDays.forEach((arrayItem) => {
                    // if (arrayItem.day == item) {
                    arrayItem.checked = false
                    // }
                    // else {
                    //     arrayItem.checked = false
                    // }
                })
            }
            console.log("this.frequencyDays ", this.frequencyDays);

        }

        if (changes.singleJobDates && changes.singleJobDates.currentValue) {
            this.singleJobDate = changes.singleJobDates.currentValue
            this.finalCourseDates = []
            this.courseDates = []
            this.singleJobDate.forEach((date) => {
                // let temp = new Date(date.date)
                // date.date = new Date(date.date)
                this.courseDates.push(date)
            })
            this.finalCourseDates = this.courseDates;
            console.log("this is the final course dates array", this.finalCourseDates);

        }




        if (changes.changeDateValue && changes.changeDateValue.currentValue) {
            // this.generateDates()
            console.log("WHAT IS THE VALUE OF FREQUENCY", this.frequency, this.frequencyDays);
            this.courseDates = []
            this.frequency.forEach((oneDay) => {
                let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                if (index > -1) {
                    console.log("index", index)
                    let dayOfWeek = this.frequencyDays[index].id
                    let event = true
                    this.generateDates(event, dayOfWeek, oneDay)
                }
            })

        }

        if (changes.viewFatigue && changes.viewFatigue.currentValue) this.isDisplay = changes.viewFatigue.currentValue


        if (changes.dateValidation && changes.dateValidation.currentValue) this.existingDates = changes.dateValidation.currentValue
        console.log("ALL ARE EXISTING JOB DATES LIST", this.existingDates)
        if (changes.jobStartTime && changes.jobStartTime.currentValue) this.startTime = changes.jobStartTime.currentValue
        if (changes.jobEndTime && changes.jobEndTime.currentValue) this.endTime = changes.jobEndTime.currentValue

    }
    onCourseChange() {
        console.log('Generating dates for', this.dateForm)

        if (this.duration <= this.finalCourseDates.length) {
            this.totalDays = this.frequency;
            console.log("Hello total Days Check ==>", this.totalDays)
            this.dateChange.emit({ singleJobDates: this.finalCourseDates.slice(0, this.duration), totalDays: this.totalDays })
        }
        else {
            this.courseDates = [];

            this.finalCourseDates = [];

            console.log("in edit!!!!", this.frequency)
            if (this.frequency) {
                this.frequency.forEach((oneDay) => {
                    let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                    if (index > -1) {
                        console.log("index", index)
                        let dayOfWeek = this.frequencyDays[index].id
                        let event = true
                        this.generateDates(event, dayOfWeek, oneDay)
                    }
                })
            }
        }
    }
    // generateDates() {
    public generateDates(event, dayOfTheWeek, day) {
        console.log("Event", event, "DayOf The week", dayOfTheWeek, "Day", day, "total days data", this.totalDays)
        console.log("starting selected date", this.courseDates, this.startingDate, this.endDate, new Date(this.startingDate).getDay());

        this.dayExist = false
        if (event == true) {
            if (new Date(this.startingDate).getDay() == dayOfTheWeek) {
                console.log("this.startingDate", this.startingDate)
                let obj = {
                    date: this.startingDate
                }
                this.courseDates.push(obj)
                console.log("IN second if")
            }
            if (this.totalDays.length < 1) {
                console.log("CHECKING LENGTH", this.frequencyDays);
                this.totalDays.push(day)
            }
            else {
                this.totalDays.forEach((item) => {
                    console.log("COMPARING EACH ITEM");
                    console.log("ITEM", item, "== Day", day);
                    if (item == day) {
                        console.log("ITEM", item, "== Day", day);
                        this.dayExist = true
                        console.log("After comparing DayExists", this.dayExist);
                    }
                })
                if (this.dayExist == false) {
                    this.totalDays.push(day)
                }
            }
            let tempDate: Date = this.temp.toDate();
            console.log("tempDate", tempDate);
            console.log("duration===>>> ", this.duration)
            for (let i = 0; i < this.duration; i++) {
                if (typeof dayOfTheWeek == 'string') dayOfTheWeek = parseInt(dayOfTheWeek)
                let days = (7 - tempDate.getDay() + dayOfTheWeek)
                if (days >= 8) {
                    days = (-1) * (7 - days);
                    console.log("In IIIFFFFF", days);
                }
                let nextDay = new Date(tempDate.setDate(tempDate.getDate() + days))
                let obj = {
                    date: tempDate
                }
                this.courseDates.push(obj)
                tempDate = nextDay;
            }
        } else {
            for (let i = 0; i < this.totalDays.length; i++) {
                if (this.totalDays[i] == day) {
                    this.totalDays.splice(i, 1)
                }
            }
            let tempDate: Date = this.temp.toDate();
            for (let i = 0; i < this.duration; i++) {
                let days = (7 - tempDate.getDay() + dayOfTheWeek)
                if (days >= 8) {
                    days = (-1) * (7 - days);
                }
                let nextDay = new Date(tempDate.setDate(tempDate.getDate() + days))
                for (let j = 0; j < this.courseDates.length; j++) {
                    if (new Date(this.courseDates[j].date).getDay() == nextDay.getDay()) {
                        this.courseDates.splice(j, 1)
                    }
                }
            }
        }
        console.log("final course date value", this.courseDates.sort((a, b) => b.date - a.date));
        let sortDates = this.courseDates.sort(function (a, b) {
            let c: any = new Date(a.date);
            let d: any = new Date(b.date);
            return c - d;
        });

        sortDates = sortDates.filter((x) => new Date(x.date) <= new Date(this.endDate))

        let verificationDates = sortDates.reverse().slice(0, this.duration);
        this.finalCourseDates = this.dateVerification(verificationDates)
        console.log("this is the temp sort dates array", this.finalCourseDates, verificationDates);
        this.dateChange.emit({ singleJobDates: this.finalCourseDates, totalDays: this.totalDays, isEdit: true })
    }
    dateVerification(newDates) {
        const dateLength = newDates.length
        console.log("EXISTING DATES LIST", this.existingDates)
        console.log("NEW GENERATED DATES", newDates)
        console.log("CURRENT JOB START AND END TIME", this.startTime, this.endTime)
        let newDateList = []
        for (let i = 0; i < dateLength; i++) {
            console.log("DATE FORMATE CHECK", typeof newDates[i].date, newDates[i].date)
            let date
            if (typeof newDates[i].date === 'string') date = newDates[i].date
            else date = ((newDates[i].date.getMonth() > 8) ? (newDates[i].date.getMonth() + 1) : ('0' + (newDates[i].date.getMonth() + 1))) + '/' + ((newDates[i].date.getDate() > 9) ? newDates[i].date.getDate() : ('0' + newDates[i].date.getDate())) + '/' + newDates[i].date.getFullYear()
            console.log("SINGLE DATE FORMATE CHANGE", date)
            let isChecked = false
            /** @fixme Why do we use find method? Fails the production build. */
            this.existingDates.map((x) => {
                x.frequencyDates.some((y) => {
                    if (y.date === date) {
                        console.log("VALUE OF EXISTING DATES", y)
                        const isCal = this.calculateDiff(x, date)
                        if (!isCal) isChecked = true
                    }
                })
            })
            if (!isChecked) {
                newDateList.push({ date: newDates[i].date })
            }
        }
        console.log("NEW GENERATED DATE LIST", newDateList)
        return newDateList.reverse()
    }

    calculateDiff(existingData, calDate) {
        console.log("EXISTING USER DATA", this.startTime, existingData, calDate)
        let tempObj = existingData.frequencyDates.find((x) => x.date === calDate)
        console.log("THIS IS THE TEMP OBJ", tempObj)
        if (tempObj !== undefined) {
            const currentDate = new Date(calDate).setHours(this.startTime.split(':')[0], this.startTime.split(':')[1])
            const preDate = new Date(calDate).setHours(existingData.endTime.split(':')[0], existingData.endTime.split(':')[1])
            const diff = (currentDate - preDate) / ((1000 * 60 * 60))
            console.log("WHAT IS THE DIFF", diff);
            if (diff > 12) {
                return true
            } else {
                return false
            }
        } else return false
    }

    public EditDates(newDate, arrayOfDays) {
        console.log('newdate assigned and all other values cleared', newDate, arrayOfDays)
        console.log("when second time date change", this.totalDays);

        if (newDate) {
            this.startingDate = newDate;
            this.temp = moment(this.startingDate)

            this.courseDates = [];

            this.finalCourseDates = [];
            if ((this.totalDays && this.totalDays.length) && this.frequency == undefined) {
                let event = true
                this.totalDays.forEach((oneDay) => {
                    let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                    if (index > -1) {
                        console.log("index", index)
                        let dayOfWeek = this.frequencyDays[index].id
                        let event = true
                        this.generateDates(event, dayOfWeek, oneDay)
                    }
                })
            }


            console.log("in edit!!!!", this.frequency)
            if (this.frequency) {
                this.frequency.forEach((oneDay) => {
                    let index = _.findIndex(this.frequencyDays, function (o) { return o.day == oneDay })
                    if (index > -1) {
                        console.log("index", index)
                        let dayOfWeek = this.frequencyDays[index].id
                        let event = true
                        this.generateDates(event, dayOfWeek, oneDay)
                    }
                })
            }
        }

        // this.generateDates('true', )
        // console.log("array of Finaldates", this.finalCourseDates)
        // console.log("array of course dates", this.courseDates)
        // this.frequencyDays.forEach((arrayItem) => {
        //     arrayItem.checked = false
        // })
        // console.log('newdate assigned and all other values cleared')
        // this.checkEnable = false;
        // this.finalCourseDates = [];
        // this.totalDays = [];
        // this.dateChange.emit({ singleJobDates: this.finalCourseDates, totalDays: this.totalDays })
    }

    public clearCheckBoxes() {
        this.frequencyDays.forEach((arrayItem) => {
            arrayItem.checked = false
        })
        this.courseDates.length = 0;
        this.finalCourseDates = [];
    }
    onChange(value, j) {
        console.log("when change date", value);
        let date = value
        console.log(this.finalCourseDates[j])
        console.log("SINGLE DATE CHANGE EVENT", date, j)

        // this.finalCourseDates.splice(j, 1, date)
        this.finalCourseDates[j]['date'] = date
        this.finalCourseDates[j]['isEdit'] = true
        // console.log(this.finalCourseDates[j])
        console.log("Hello Here is the total days count ====>", this.totalDays)
        this.dateChange.emit({ singleJobDates: this.finalCourseDates.slice(0, this.duration), totalDays: this.totalDays, isEdit: true })
    }

    dateFilter = (d: Date) => {

        const arrayListDate = this.finalCourseDates.map((o) => {
            return new Date(o.date).valueOf()

        })

        return arrayListDate.indexOf(d.valueOf()) == -1;
    };
}